module.exports = __webpack_public_path__ + "img/maker.4c508c31.svg";